"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
(function ($) {
    $.fn.unveilBackground = function (threshold, callback) {
        var $w = $(window), th = threshold || 0, attrib, elements = this, loaded;
        attrib = 'data-background-src';
        if (window.devicePixelRatio > 1) {
            attrib = 'data-background-src-x2';
            if (window.devicePixelRatio > 2) {
                attrib = 'data-background-src-x3';
            }
        }
        this.one("unveil", function () {
            var source = this.getAttribute(attrib);
            source = source || this.getAttribute("data-background-src");
            if (txGs1Base.respond.getBreakpoint() === 'desktop') {
                if ($w.width() > 1350 && $(this).prop('id') === 'background') {
                    source = this.getAttribute('data-background-src-x2');
                }
            }
            if (source) {
                $(this).css('background-image', 'url(' + source + ')');
                if (typeof callback === "function") {
                    callback.call(this);
                }
            }
        });
        function unveil() {
            var inview = elements.filter(function () {
                var $e = $(this);
                if ($e.is(":hidden")) {
                    return undefined;
                }
                var wt = $w.scrollTop(), wb = wt + $w.height(), et = $e.offset().top, eb = et + $e.height();
                return eb >= wt - th && et <= wb + th;
            });
            loaded = inview.trigger("unveil");
            elements = elements.not(loaded);
        }
        $w.on('scroll', unveil);
        $w.on('resize', unveil);
        unveil();
        return this;
    };
})(window.jQuery);
exports.default = {};
